import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA, TEXT_SCHEMA, BUTTON_SCHEMA, OBSERVATION_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const TICKETS_ITEM_OPTION = () => ({
  link: '',
  title: 'Título',
  description: 'Descrição',
  price: '',
  backgroundColor: '',
  buttonText: '',
  buttonColor: '',
  buttonTextColor: '',
  visible: false
})

const TYPE_TICKET = () => ({
  codigo_grupo: 1,
  codigo_produto: 1,
  codigo_tipo: 1,
  extradata: [{codigo: 1, conteudo: '', obrigatorio: 1, order: 1, tipo: '', titulo: '', unico: 0, valor: '', opcoes: ['']}],
  nome: 'default-style',
  nome_grupo: '',
  nome_tipo: '',
  valor: 1
})

/* exclusive for newLayout1,2,3,4,5,6 */
export const TICKETS_LAYOUT_SELECTED_ITEMS = () => ({
  codigo: -1,
  codigo_tipo: -1,
  mensagem: '',
  destaque: false,
  itens_incluidos: [''] 
})

export const TICKETS_LAYOUT_ITEMS_DESC = () => ({
  id: '',
  group: '',
  isOpen: false, // only for expansion
  noNamedGroup: false,
  items: [{id: '', description: ''}]
})

export const NEW_LAYOUT_STYLE = (style) => ({
  accentColor1: '', 
  accentColor2: '', 
  btnColor1: {bg: '', text: '', border: ''}, 
  btnColor2: {bg: '', text: '', border: ''},
  btnColor3: {bg: '', text: '', border: ''},
  btnColor4: {bg: '', text: '', border: ''},
  checkColor1: {bgChecked: '', colorChecked: '', bgNotChecked: '', colorNotChecked: ''},
  checkColor2: {bgChecked: '', colorChecked: '', bgNotChecked: '', colorNotChecked: ''},
  bgColor: '',
  featuredBgColor1: '',
  featuredBgColor2: '',
  itemColor: '',
  itemBgColor: '',
  priceColor: '',
  textColor1: '',
  textColor2: '',
  width: TICKETS_GET_DEFAULT_WIDTH(style).width,
  featuredWidth: TICKETS_GET_DEFAULT_WIDTH(style).featuredWidth 
})

// newLayoutType = newLayout1, newLayout2, newLayout3, newLayout4, newLayout5, newLayout6
export const TICKETS_GET_DEFAULT_WIDTH = (newlayoutType) => {
  const widths = {
    newLayout1: {width: 250, featuredWidth: 280},
    newLayout2: {width: 250, featuredWidth: 290},
    newLayout3: {width: 245, featuredWidth: 245},
    newLayout4: {width: 220, featuredWidth: 220},
    newLayout5: {width: 220, featuredWidth: 220},
    newLayout6: {width: 220, featuredWidth: 220}
  }

  return widths[newlayoutType]
}
/* end exclusive for newLayout1,2,3,4,5,6 */

export const TICKETS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'tickets',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Ingressos'),
    subtitle: SUBTITLE_SCHEMA(),
    text: TEXT_SCHEMA(),
    observation: OBSERVATION_SCHEMA('* observação sobre os ingressos'),
    bg: BG_SCHEMA(),
    buttons: [BUTTON_SCHEMA()],
    layout: 'horizontal', // horizontal, vertical, form, custom, newLayout1,2,3,4,5,6
    // exclusive for custom
    items: [TICKETS_ITEM_OPTION()], // layout: custom
    // exclusive for form
    'text-color': '#202020',
    'layer-color': '#FFFFFF',
    'type-ticket': TYPE_TICKET(),
    // exclusive for vertical and custom
    'max-columns': 3,
    'item-background-color': '#f5f5f5',
    // exclusive for newLayout1,2,3,4,5,6
    itemsV2: [TICKETS_LAYOUT_SELECTED_ITEMS()],
    itemsV2Desc: [TICKETS_LAYOUT_ITEMS_DESC()],
    itemsV2Message: 'Neste ingresso está incluso:',
    itemsV2Button: 'Comprar ingresso',
    checkoutV2ByProduct: false,
    showTypeOfTicket: true,
    layoutStyle: {
      newLayout1: NEW_LAYOUT_STYLE('newLayout1'),
      newLayout2: NEW_LAYOUT_STYLE('newLayout2'),
      newLayout3: NEW_LAYOUT_STYLE('newLayout3'),
      newLayout4: NEW_LAYOUT_STYLE('newLayout4'),
      newLayout5: NEW_LAYOUT_STYLE('newLayout5'),
      newLayout6: NEW_LAYOUT_STYLE('newLayout6')
    }
  }
}

export const beforeParseTickets = target => {
  commonBeforeParseMethod(target, ['bg'])
  if (!target.buttons) Object.assign(target, {buttons: [BUTTON_SCHEMA()]})
}

export const TICKETS_SECTION = config => ({
  schema: TICKETS_SCHEMA(config),
  beforeParse: beforeParseTickets
})
